import { Button, Collapse, Form, Select } from "antd";
import styled from "styled-components";
import BbotAccordion from "top-component-library/BbotAccordion";

import { FulfillmentMethodPrettyNames } from "../types";

interface CustomKdsTicketColorsSectionProps {
  colorMethods: string[];
  fulfillmentMethodPrettyNames: FulfillmentMethodPrettyNames;
  onAddMethod: (method: string) => void;
  onRemoveMethod: (method: string) => void;
}

// Per-fulfillment-method KDS ticket color overrides. The set of methods that currently have a
// color is owned by the modal (colorMethods); each color value is a form field so it round-trips
// through custom_kds_ticket_colors. Selecting a method in the dropdown adds a row; Remove drops it.
const CustomKdsTicketColorsSection = ({
  colorMethods,
  fulfillmentMethodPrettyNames,
  onAddMethod,
  onRemoveMethod,
}: CustomKdsTicketColorsSectionProps) => {
  const availableMethods = Object.keys(fulfillmentMethodPrettyNames).filter((method) => !colorMethods.includes(method));

  return (
    <BbotAccordion>
      <Collapse.Panel header="Custom KDS Ticket Colors" key="custom-kds-colors">
        {colorMethods.map((method) => (
          <ColorRow key={method}>
            <span>{fulfillmentMethodPrettyNames[method] || method}:</span>
            <Form.Item name={["custom_kds_ticket_colors", method]} noStyle>
              <input type="color" aria-label={`${method} ticket color`} />
            </Form.Item>
            <Button type="link" danger onClick={() => onRemoveMethod(method)}>
              Remove
            </Button>
          </ColorRow>
        ))}
        <ColorRow>
          <label htmlFor="dp-add-kds-color">Override KDS Ticket Color for:</label>
          <Select
            id="dp-add-kds-color"
            placeholder="Select a fulfillment method"
            value={null}
            onChange={onAddMethod}
            options={availableMethods
              .map((method) => ({
                label: fulfillmentMethodPrettyNames[method] || method,
                value: method,
              }))
              .sort((a, b) => a.label.localeCompare(b.label))}
            style={{ minWidth: 240 }}
          />
        </ColorRow>
      </Collapse.Panel>
    </BbotAccordion>
  );
};

export default CustomKdsTicketColorsSection;

const ColorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;
